const middleware = {}

middleware['headers'] = require('../middleware/headers.ts')
middleware['headers'] = middleware['headers'].default || middleware['headers']

middleware['navigation'] = require('../middleware/navigation.ts')
middleware['navigation'] = middleware['navigation'].default || middleware['navigation']

middleware['redirects'] = require('../middleware/redirects.ts')
middleware['redirects'] = middleware['redirects'].default || middleware['redirects']

middleware['weather'] = require('../middleware/weather.ts')
middleware['weather'] = middleware['weather'].default || middleware['weather']

export default middleware
